const light = ({ targetColorPalette }) => targetColorPalette[0];

export default light;
